import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../../styles/Team.module.css';

const Navigation = () => {
  const location = useLocation();
  
  const navItems = [
    { path: '/team', label: 'Dashboard', icon: <FontAwesomeIcon icon="chart-line" /> },
    { path: '/team/affiliate', label: 'Affiliate', icon: <FontAwesomeIcon icon="handshake" /> },
    { path: '/team/monetized', label: 'Monetized', icon: <FontAwesomeIcon icon="dollar-sign" /> }
  ];

  return (
    <nav className={styles.desktopNav}>
      <div className={styles.desktopNavLinks}>
        {navItems.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => {
              // For dashboard (root path), only active if exactly on /team
              if (item.path === '/team') {
                return `${styles.desktopNavLink} ${location.pathname === '/team' ? styles.active : ''}`;
              }
              // For other paths, use default isActive behavior
              return `${styles.desktopNavLink} ${isActive ? styles.active : ''}`;
            }}
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default Navigation; 